import { Injectable } from '@angular/core';
import {  ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { SessionStorageService } from 'ngx-webstorage';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, public session: SessionStorageService) { }
  canActivate(): boolean {
    if (this.session.retrieve("isLogIN") == true) {
      return true;
    }
    else {
      this.router.navigate(["login"]);
      return false;
    }
  }
}
@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  roleId: any;
  hasAccess: any;
  userType: any;
  constructor(private router: Router, public session: SessionStorageService) { }
  canActivate(route:ActivatedRouteSnapshot): boolean {
    this.roleId=this.session.retrieve("UserDetails").roleId;
    this.userType = this.session.retrieve("UserDetails").userType;
    this.hasAccess= route.data.role  || this.userType === 'admin';
    if (this.hasAccess.includes(parseInt(this.roleId))  || this.userType === 'admin') {
      return true;
    }
    else {
      this.router.navigate(["/mscvp/unAuth"]);
      return false;
    }
  }
}
